import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const organizationCreatedV1Schema = eventEnvelopeSchema.extend({
  clerkOrganizationId: z.string().min(1).max(256).optional(),
  createdByUserId: z.string().min(1).max(256).optional(),
  activationPath: z.string().min(1).max(128).optional(),
  stripeAccountId: z.string().min(1).max(256).optional(),
  selectedPlan: z.string().min(1).max(128).optional(),
  entityType: z.string().min(1).max(128).optional(),
  hasWebsite: z.boolean().optional(),
});

export type OrganizationCreatedV1 = z.infer<typeof organizationCreatedV1Schema>;

export const ORGANIZATION_CREATED_V1_DETAIL_TYPE = 'organization.created.v1' as const;
